import api from "./apiService";

/**
 * Global Search API (POST request with filter payload)
 * @param {Object} payload - Search criteria payload
 */
export const globalSearch = async (payload) => {
  return api.post("/global/globalSearch", payload);
};

/**
 * Fetch list of survey sectors
 */
export const getSectors = async () => {
  return api.post("/survey/sectors", {});
};

/**
 * Fetch list of survey countries
 */
export const getCountries = async () => {
  return api.post("/survey/countries", {});
};

/**
 * Fetch list of company names
 */
export const getCompanyNames = async () => {
  return api.post("/company/fetch-companyNames", {});
};

/**
 * Fetch list of company revenues
 */
export const getCompanyRevenue = async () => {
  return api.post("/survey/Company-Revenue", {});
};

/**
 * Fetch list of company sizes
 */
export const getCompanySize = async () => {
  return api.post("/survey/Company-Size", {});
};



/**
 * Fetch list of company types
 */
export const getCompanyType = async () => {
  return api.post("/survey/company-type", {});
};

const globalSearchService = {
  globalSearch,
  getSectors,
  getCountries,
  getCompanyNames,
  getCompanyRevenue,
  getCompanySize,
  getCompanyType,
};

export default globalSearchService;
